var e=()=>n,n=t=>t;export{e as a};
